import 'css-chunksrc/client/scenes/listCreation/styles.scss';export default {
  "listCreation": "_listCreation_1hm5u_1",
  "main": "_main_1hm5u_8",
  "buttons": "_buttons_1hm5u_20",
  "action": "_action_1hm5u_29"
};